module.exports = __webpack_public_path__ + "img/footer-logo.20807ada.png";